<template @getCategory="getCategoryList()">
  <div>
    <v-toolbar flat>
      <v-spacer></v-spacer>
      <v-btn
        @click="openAddActivityDialog"
        color="primary"
        dark
        class="btn-responsive"
      >
        <v-icon class="mr-2">mdi-plus-circle</v-icon>เพิ่มข่าวสารและกิจกรรม
      </v-btn>
    </v-toolbar>
    <v-data-table
      :headers="headers_event"
      :items="activityListFilter"
      :items-per-page="5"
    >
      <template v-slot:item.no="{ item }"
        >{{ activityListFilter.indexOf(item) + 1 }}.</template
      >
      <template v-slot:item.event_name="{ item }">{{
        lenght_data(item.event_name)
      }}</template>
      <template v-slot:item.event_detail="{ item }"
        ><span v-html="lenght_data(item.event_detail)"></span
      ></template>
      <template v-slot:item.event_start_date="{ item }">{{
        formatDate(item.event_start_date)
      }}</template>
      <template v-slot:item.event_end_date="{ item }">{{
        formatDate(item.event_end_date)
      }}</template>
      <template v-slot:item.action="{ item }">
        <v-btn icon @click="dialogAddEdit(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon @click="deleteData(item)">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <!-- Dialog add Item -->
    <v-dialog
      v-model="dialog_news_setting"
      persistent
      max-width="700px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title style="background-color: rgba(227, 236, 238, 0.9)">
          <span class="font-weight-bold">{{ formTitle }}</span>
          <v-spacer></v-spacer>
          <v-btn icon class="float-right" @click="close()">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="py-4 pt-6">
          <v-form ref="form">
            <v-text-field
              v-model="news_event.event_name"
              label="หัวข้อ"
              outlined
              :rules="rule_field_is_empty_name"
              required
            ></v-text-field>
            <v-autocomplete
              v-model="news_event.category_id"
              outlined
              :rules="rule_field_is_empty"
              label="หมวดหมู่"
              :items="categoryList"
              item-text="category_name"
              item-value="category_id"
              :disabled="show_disable"
              :readonly="show_disable"
            ></v-autocomplete>
            <v-autocomplete
              v-if="news_event.category_id == '1'"
              v-model="news_event.event_position_id"
              outlined
              :rules="rule_field_is_empty"
              label="หมวดย่อย"
              :items="categoryType"
              item-text="event_position_name"
              item-value="event_position_id"
              :readonly="show_disable"
              :disabled="show_disable"
            ></v-autocomplete>
            <!-- <v-textarea
              
              label="รายละเอียด"
              outlined
              
            ></v-textarea> -->
            <quill-editor
              ref="myQuillEditor"
              class="ql-container ql-formats"
              v-model="news_event.event_detail"
              :rules="rule_field_is_empty"
              required
              :options="editorOption"
            ></quill-editor>
            <v-row class="pt-8">
              <v-col cols="6" class="py-0">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="news_event.event_start_date"
                      label="วันที่เริ่ม"
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar"
                      :rules="rule_field_is_empty"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="news_event.event_start_date"
                    @input="menu = false"
                    no-title
                    scrollable
                    :max="news_event.event_end_date"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="news_event.event_end_date"
                      label="วันสิ้นสุด"
                      outlined
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      append-icon="mdi-calendar"
                      :rules="rule_field_is_empty"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="news_event.event_end_date"
                    @input="menu2 = false"
                    no-title
                    scrollable
                    :min="news_event.event_start_date"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-menu
                  ref="menu3"
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="news_event.event_start_time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="news_event.event_start_time"
                      label="เวลาเริ่ม"
                      append-icon="mdi-clock"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      :rules="rule_field_is_empty"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu3"
                    v-model="news_event.event_start_time"
                    full-width
                    :max="news_event.event_end_time"
                    @click:minute="
                      $refs.menu3.save(news_event.event_start_time)
                    "
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-menu
                  ref="menu4"
                  v-model="menu4"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  :return-value.sync="news_event.event_end_time"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="news_event.event_end_time"
                      label="เวลาสิ้นสุด"
                      append-icon="mdi-clock"
                      readonly
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      :rules="rule_field_is_empty"
                    ></v-text-field>
                  </template>
                  <v-time-picker
                    v-if="menu4"
                    v-model="news_event.event_end_time"
                    full-width
                    :min="news_event.event_start_time"
                    @click:minute="$refs.menu4.save(news_event.event_end_time)"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row class="py-0">
              <v-col cols="12" class="py-0">
                <v-card outlined style="border: 1px solid rgba(0, 0, 0, 0.38)">
                  <label :for="namephotofile">
                    <p class="pt-5 px-3 py-1">
                      อัปโหลดรูปภาพ
                      <v-icon class="float-right">mdi-cloud-upload</v-icon>
                    </p>
                  </label>
                </v-card>
              </v-col>
            </v-row>
            <!-- <pre>{{file_image_from_api}}</pre> -->
            <v-row>
              <v-col
                :cols="index == 0 ? '12' : '4'"
                align="center"
                justify="center"
                v-for="(file, index) in file_image_from_api"
                :key="file.event_file_id"
              >
                <v-card class="text-center pa-1 pt-3 ma-1">
                  <v-card-title class="py-0">
                    <v-spacer></v-spacer>
                    <v-btn
                      small
                      icon
                      @click="deleteImage(index, file.event_file_id)"
                    >
                      <v-icon small class="float-right"
                        >mdi-window-close</v-icon
                      >
                    </v-btn>
                  </v-card-title>
                  <img
                    class="float-center"
                    v-if="file.event_file_path"
                    :src="env + '/' + file.event_file_path"
                    :width="index == 0 ? '580px' : '160px'"
                    :height="index == 0 ? '250px' : '160px'"
                  />
                </v-card>
              </v-col>

              <v-col
                v-show="file_image != []"
                :cols="index == 0 && file_image_from_api == [] ? '12' : '4'"
                align="center"
                justify="center"
                v-for="(file, index) in file_image"
                :key="index"
              >
                <v-card class="text-center pa-1 pt-3 ma-1">
                  <v-card-title class="py-0">
                    <v-spacer></v-spacer>
                    <v-btn small icon @click="removeImage(index)">
                      <v-icon small class="float-right"
                        >mdi-window-close</v-icon
                      >
                    </v-btn>
                  </v-card-title>
                  <img
                    class="float-center"
                    v-if="file.thumb"
                    :src="file.thumb"
                    :width="
                      index == 0 && file_image_from_api == []
                        ? '580px'
                        : '160px'
                    "
                    :height="
                      index == 0 && file_image_from_api == []
                        ? '250px'
                        : '160px'
                    "
                  />
                </v-card>
              </v-col>
            </v-row>

            <file-upload
              class="btn btn-primary dropdown-toggle"
              input-id="photofile"
              :directory="directory"
              :accept="acceptphoto"
              :extensions="extensionsphoto"
              :size="size || 0"
              :thread="thread < 1 ? 1 : thread > 5 ? 5 : thread"
              :headers="headers"
              :data="data"
              :drop="drop"
              :multiple="multiple"
              @input-filter="inputFilter"
              v-model="file_image"
              @input-file="inputFile"
              ref="event_media"
            ></file-upload>
          </v-form>
        </v-card-text>
        <v-card-actions class="pt-5">
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click="close">ยกเลิก</v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="click"
            text
            @click="saveEvent()"
            >บันทึก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import FileUpload from "vue-upload-component";
import { bus } from "@/main";

export default {
  components: {
    FileUpload,
  },
  data() {
    return {
      current_category: null,
      current_position: null,
      show_disable: false,
      click: false,
      // today: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      dialog_news_setting: false,
      rule_field_is_empty: [
        (v) => !!v || "กรุณากรอกข้อมูล",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      rule_field_is_empty_name: [
        (v) => !!v || "กรุณากรอกข้อมูล",
        // (v) => (!!v ? v.length <= 255 : false) || "ข้อความมีความยาวมากเกินไป",
        (v) => (!!v ? v[0] != " " : false) || "ห้ามขึ้นต้นด้วยค่าว่าง",
      ],
      env: process.env.VUE_APP_API,
      minSize: 1024,
      size: 1024 * 1024 * 10,
      multiple: true,
      acceptphoto: "image/png,image/jpeg,image/jpg", //,video/mp4,video/x-m4v,video/*
      extensionsphoto: "jpg,jpeg,png",
      directory: false,
      drop: false,
      thread: 3,
      postAction: "/upload/post",
      headers: {
        "X-Csrf-Token": "xxxx",
      },
      data: {
        _csrf_token: "xxxxxx",
      },
      autoCompress: 1024 * 1024,
      uploadAuto: true,
      namephotofile: "photofile",
      header_token: {
        headers: { Authorization: "Bearer " + this.$session.get("token") },
      },
      editedIndex: -1,
      // dialog_add_edit: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      file_image: [],
      file_image_from_api: [],
      news_event: {
        event_name: "",
        event_position_id: 7,
        event_detail: "",
        category_id: 0,
        event_start_date: null,
        event_end_date: null,
        event_start_time: null,
        event_end_time: null,
      },
      dialog_news_setting: false,
      dialog: false,
      event_data: [],
      event_data_file: [],

      news_list: [],
      response_data: "",
      event_id: null,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            // [{ header: 1 }, { header: 2 }],

            // [{ size: ["small", false, "large", "huge"] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            // [{ font: [] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["clean"],
            // ['link', 'image', 'video']
            ["link"],
          ],
          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value,
          },
        },
      },
      headers_event: [
        {
          text: "ลำดับ",
          value: "no",
          sortable: false,
          align: "center",
          width: "10%",
        },
        {
          text: "หัวข้อ",
          value: "event_name",
          sortable: false,
          align: "left",
          width: "20%",
        },
        {
          text: "รายละเอียด",
          value: "event_detail",
          sortable: false,
          align: "left",
          width: "20%",
        },
        {
          text: "วันที่เริ่ม",
          value: "event_start_date",
          sortable: false,
          align: "left",
          width: "10%",
        },

        {
          text: "วันสิ้นสุด",
          value: "event_end_date",
          sortable: false,
          align: "left",
          width: "10%",
        },
        {
          text: "หมวดหมู่",
          value: "category_name",
          sortable: false,
          align: "left",
          width: "10%",
        },
        {
          text: "จัดการ",
          value: "action",
          sortable: false,
          align: "center",
          width: "20%",
        },
      ],
      activityList: [],
      categoryList: [],
      edit_img: "",
      // new activity variable
      activity_name: "",
      activity_detail: "",
      activity_start_date: "",
      activity_end_date: "",
      category: "",
      menu_start_date: false,
      menu_end_date: false,
      file_id_list: [],
      all_file_from_api: [],
      categoryType: [
        { event_position_id: 1, event_position_name: "นักศึกษาแพทย์" },
        { event_position_id: 2, event_position_name: "แพทย์ประจำบ้าน" },
        {
          event_position_id: 3,
          event_position_name: "พยาบาลเพิ่มพูนทักษะวิสัญญี",
        },
        { event_position_id: 4, event_position_name: "กิจกรรมสาขาวิชา" },
        { event_position_id: 5, event_position_name: "ข่าวโรงพยาบาลและคณะ" },
        { event_position_id: 6, event_position_name: "บริการวิชาการต่อสังคม" },
      ],
      response_status: false,
      event_category_id_from_path: 0,
      event_position_id_from_path: 7,
    };
  },
  computed: {
    activityListFilter() {
      return this.activityList.filter((item) => {
        // console.log(item.event_position_id);
        if (this.current_category) {
          if (this.current_category == 1) {
            return this.current_position == item.event_position_id;
          } else {
            return this.current_category == item.category_id;
          }
        } else {
          return true;
        }
        // return this.current_category
        //   ? item.category_id == this.current_category
        //   : true;
      });
    },
    formTitle() {
      return this.editedIndex == -1
        ? "เพิ่มข่าวสารและกิจกรรม"
        : "แก้ไขข่าวสารและกิจกรรม";
    },
  },
  watch: {
    response_status(val) {
      if (val == true) {
        this.getActivityList();
      }
    },
    "$store.state.category_status"(val) {
      if (val == true) {
        this.getCategoryList();
        this.getActivityList();
      }
    },
  },
  created() {
    this.getCategoryList();
    this.getActivityList();
  },
  methods: {
    filterActivityByCategory(category_id, position_id) {
      if (category_id != "all") {
        this.current_category = category_id;
        if (category_id == 1) {
          this.current_position = position_id;
        } else {
          this.current_position = null;
        }
      } else {
        this.current_category = null;
        this.current_position = null;
      }
    },
    openAddActivityDialog() {
      this.getCategoryList();
      // console.log(window.location.pathname);
      if (this.$route.query.id) {
        // console.log(this.$route.query.id);
        this.event_category_id_from_path = 1;
        this.event_position_id_from_path = parseInt(this.$route.query.id);
        this.show_disable = true;
      } else if (window.location.pathname == "/calendarweek") {
        this.event_category_id_from_path = 5;
        this.event_position_id_from_path = 7;
        this.show_disable = true;
      } else {
        this.event_category_id_from_path = 0;
        this.event_position_id_from_path = 7;
      }

      this.file_id_list = [];
      this.dialog_news_setting = true;
      this.menu = false;
      this.menu2 = false;
      this.menu3 = false;
      this.menu4 = false;
      this.news_event = {
        event_name: "",
        event_position_id: this.event_position_id_from_path,
        event_detail: "",
        category_id: this.event_category_id_from_path,
        event_start_date: null,
        event_end_date: null,
        event_start_time: "",
        event_end_time: "",
      };
      setTimeout(() => {
        // this.$refs.form.reset();
        this.$refs.form.resetValidation();
      }, 100);
    },
    getCategoryList() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/category")
        .then((response) => {
          let category = [];
          category = response.data;
          this.categoryList = category;
        });
    },
    getActivityList() {
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/event_cat")
        .then((response) => {
          let get_event = [];
          get_event = response.data;
          this.activityList = get_event;
          // console.log(get_event);
        });
    },

    inputFile(newFile) {},
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        newFile.thumb = "";
        if (newFile.blob && newFile.type.substr(0, 6) === "image/") {
          newFile.thumb = newFile.blob;
        }
      }
    },
    dialogAddEdit(item) {
      // console.log(item);
      this.$store.state.news_status = null;
      if (item == "") {
        //add
        this.editedIndex = -1;
        this.formTitle = "Add news or activity";
        this.file_image = [];
        this.news_event = {
          event_name: "",
          event_detail: "",
          event_position_id: 7,
          category_id: 0,
          event_start_date: null,
          event_end_date: null,
          event_start_time: null,
          event_end_time: null,
        };
        if (window.location.pathname == "/calendarweek") {
          this.show_disable = true;
        }
        this.dialog_news_setting = true;
        setTimeout(() => {
          // this.$refs.form.reset();
          this.$refs.form.resetValidation();
        }, 100);
      } else if (item.event_id >= 0) {
        this.file_id_list = [];
        //edit
        // console.log(item);
        if (window.location.pathname == "/calendarweek") {
          this.show_disable = true;
        }
        this.$route.query.id ? (this.show_disable = true) : "";
        this.editedIndex = item.event_id;

        this.file_image = [];
        this.all_file_from_api = [];
        this.file_image_from_api = [];
        this.all_file_from_api = item.file;
        // this.file_image_from_api = item.file;
        let file = [];
        item.file.forEach((element) => {
          file.push(element);
        });
        this.file_image_from_api = file;
        this.old_file_image_from_api = item.file;

        this.news_event = {
          category_id: item.category_id,
          event_position_id: item.event_position_id,
          event_name: item.event_name,
          event_detail: item.event_detail,
          event_start_date: item.event_start_date,
          event_end_date: item.event_end_date,
          event_start_time: item.event_start_time,
          event_end_time: item.event_end_time,
        };
        this.dialog_news_setting = true;
      }
    },
    removeImage(id) {
      this.$refs.event_media.remove(this.file_image[id]);
    },

    deleteImage(index, event_file_id) {
      // console.log(event_file_id);

      this.file_image_from_api.splice(index, 1);
      this.file_id_list.push(event_file_id);
      // console.log(this.file_id_list);
      // this.axios
      //   .delete(
      //     process.env.VUE_APP_API + "/api/v1/eventfile/" + event_file_id,
      //     this.header_token
      //   )
      //   .then(response => {
      //     if (response.data == "delete success") {
      //       this.file_image_from_api.splice(index, 1);
      //     } else {
      //       console.log("ไม่สามารถลบได้");
      //     }
      //   });
    },

    saveEvent() {
      // if (this.file_image_from_api.length > 0 || this.file_image.length > 0) {
      if (this.$refs.form.validate()) {
        // if (this.$refs.event_media.files != "") {
        // console.log(this.editedIndex);
        this.$store.state.news_status = null;
        if (this.editedIndex > -1) {
          this.click = true;
          this.$store.state.morning_status = null;
          this.putEvent(this.editedIndex);
        } else {
          this.click = true;
          this.$store.state.morning_status = null;
          this.postEvent();
        }
      }
      // } else {
      //   this.$swal.fire({
      //     icon: "error",
      //     title: "กรุณาตรวจสอบไฟล์",
      //     showConfirmButton: false,
      //     timer: 1000
      //   });
      // }
    },
    postEvent() {
      this.event_id = null;
      let data = {};
      data = this.news_event;
      // console.log(data);
      if (this.file_image != []) {
        this.axios
          .post(
            process.env.VUE_APP_API + "/api/v1/event",
            data,
            this.header_token
          )
          .then((response) => {
            let event_id = "";
            this.event_id = response.data.eventid;
            if (response.data) {
              // console.log(response.data);
              this.event_id = response.data.eventid;
              if (this.file_image.length == 0) {
                this.$swal.fire({
                  icon: "success",
                  title: "เพิ่มข้อมูลสำเร็จ",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.click = false;

                this.getActivityList();
                this.$emit("getNews", "add");
                this.response_status = true;
                this.$store.state.event_status = this.current_position;
                this.$store.state.news_status = true;
                this.$store.state.morning_status = true;

                this.close();
              } else {
                this.postEventFile(this.event_id);
              }
            }
            // event_id = response.data.event_id;
            // if (response.data) {

            // }
          });
      }
    },

    updateImg(id) {
      var event_id = id;
      var update_file = [];

      this.all_file_from_api.forEach((element) => {
        var include = this.file_id_list.includes(element.event_file_id);
        if (include == false) {
          update_file.push(element.event_file_id);
        }
      });
      var data = {
        file: update_file,
      };
      this.axios
        .put(
          process.env.VUE_APP_API + "/api/v1/eventfile/" + event_id,
          data,
          this.header_token
        )
        .then((res) => {
          // console.log(res.data);
          if (res.data == "update success") {
            if (this.file_image.length == 0) {
              this.$swal.fire({
                icon: "success",
                title: "แก้ไขข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1000,
              });
              this.getActivityList();
              this.close();
            }
          }
        });
    },
    checkLengthFileName(val) {
      let name_file = "";
      if (val.length < 45) {
        name_file = val;
        return name_file;
      } else {
        name_file = val.slice(0, 40);
        name_file += ".png";
        return name_file;
      }
    },
    postEventFile(id) {
      // console.log(this.file_image);

      if (this.file_id_list.length > 0) {
        this.updateImg(id);
      }
      var event_id = id;
      let form = new FormData();

      if (this.file_image.length != 0) {
        let res_img = [];
        for (let i = 0; i < this.file_image.length; i++) {
          form = new FormData();
          // this.file_image[i].file.name = this.checkLengthFileName(
          //   this.file_image[i].file.name
          // );
          // console.log(this.file_image[i].file.name);
          form.append(
            "file",
            this.file_image[i].file,
            this.checkLengthFileName(this.file_image[i].file.name) + i
          );
          this.axios
            .post(
              process.env.VUE_APP_API + "/api/v1/eventfile/" + event_id,
              form,
              this.header_token
            )
            .then((response) => {
              // console.log(response.data);

              if (response.data == "upload success") {
                // console.log(this.edit_img);
                // if (this.edit_img == "edit") {
                //   this.$swal.fire({
                //     icon: "success",
                //     title: "แก้ไขข้อมูลสำเร็จ",
                //     showConfirmButton: false,
                //     timer: 1000,
                //   });
                // } else {
                //   this.$swal.fire({
                //     icon: "success",
                //     title: "เพิ่มข้อมูลสำเร็จ",
                //     showConfirmButton: false,
                //     timer: 1000,
                //   });
                // }
                res_img.push("success");

                // this.getActivityList();
                // this.$emit("getNews", "ok");
                // this.$store.state.event_status = this.current_position;
                // this.$store.state.news_status = true;
                this.$store.state.morning_status = true;
                // this.edit_img == "";

                // this.close();
              } else {
                // this.$swal.fire({
                //   icon: "error",
                //   title: "ผิดพลาด",
                // });
                res_img.push("error");
                // this.getActivityList();

                // this.close();
              }
              form = new FormData();
            })
            .catch((err) => {
              res_img.push("error");
            });
        }
        setTimeout(() => {
          var check_response = res_img.indexOf("error");

          if (check_response < 0) {
            if (this.edit_img == "edit") {
              this.$swal.fire({
                icon: "success",
                title: "แก้ไขข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1000,
              });
            } else {
              this.$swal.fire({
                icon: "success",
                title: "เพิ่มข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1000,
              });
            }
            this.getActivityList();
            this.$emit("getNews", "edit");
            this.$store.state.event_status = this.current_position;
            this.$store.state.news_status = true;
            this.$store.state.morning_status = true;
            this.edit_img == "";
          } else {
            this.$swal.fire({
              icon: "warning",
              title: "ผิดพลาด",
              text: "เกิดข้อผิดพลาดบางประการ กรุณาตรวจสอบรูปภาพอีกครั้ง",
              showConfirmButton: false,
              timer: 4000,
              showCloseButton: true,
            });
            this.getActivityList();
            this.$emit("getNews", "edit");
            this.$store.state.event_status = this.current_position;
            this.$store.state.news_status = true;
            this.$store.state.morning_status = true;
            this.edit_img == "";

            // setTimeout(() => {
            //   this.close();
            // }, 2500);
          }
        }, 2000);
        setTimeout(() => {
          this.close();
        }, 2500);
      }
    },
    // displayResponse(val) {
    //   if (val == true) {
    //     this.$swal.fire({
    //       icon: "success",
    //       title: "เพิ่มข้อมูลสำเร็จ",
    //       showConfirmButton: false,
    //       timer: 1000
    //     });
    //     this.getActivityList();
    //     this.$emit("getNews", "ok");
    //     this.close();
    //   } else {
    //     this.$swal.fire({
    //       icon: "error",
    //       title: "ไม่สามารถเพิ่มรูปภาพได้"
    //       // showConfirmButton: false,
    //       // timer: 1000
    //     });
    //     this.getActivityList();
    //     this.$emit("getNews", "ok");
    //     this.close();
    //   }
    // },
    putEvent(id) {
      // console.log("puttttttttttttttttt");
      let data = this.news_event;
      data.category_id != 1 ? (data.event_position_id = 0) : "";
      // console.log(data);
      this.event_id = null;
      this.axios
        .put(
          process.env.VUE_APP_API + "/api/v1/event/" + id,
          data,
          this.header_token
        )
        .then((response) => {
          // console.log(response.data);
          if (response.data == "edit success") {
            this.event_id = id;
            if (this.file_image.length != 0 || this.file_id_list.length > 0) {
              this.edit_img = "edit";
              this.postEventFile(this.event_id);
            } else {
              this.$swal.fire({
                icon: "success",
                title: "แก้ไขข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1000,
              });
              this.click = false;
              this.getActivityList();
              this.$emit("getNews", "edit");
              this.response_status = true;
              this.$store.state.event_status = this.current_position;
              this.$store.state.news_status = true;
              this.$store.state.morning_status = true;

              this.close();
            }

            // this.postEventFile(id);
          }
        });
    },
    close() {
      this.$store.state.news_status = null;
      this.file_image_from_api = this.old_file_image_from_api;
      this.click = false;
      this.file_id_list = [];
      // this.$refs.form.resetValidation();
      // this.$refs.form.reset();
      this.response_status = false;
      this.editedIndex = -1;
      this.file_image.forEach((element, n) => {
        this.$refs.event_media.remove(this.file_image[n]);
      });

      this.file_image = [];
      this.all_file_from_api = [];
      this.all_file_from_api = "";
      this.file_image_from_api = [];
      this.file_image_from_api = "";
      this.news_event = {};
      this.news_event = {
        event_name: "",
        event_position_id: 7,
        event_detail: "",
        category_id: 0,
        event_start_date: null,
        event_end_date: null,
        event_start_time: null,
        event_end_time: null,
      };
      this.menu = false;
      this.menu2 = false;
      this.menu3 = false;
      this.menu4 = false;
      this.dialog_news_setting = false;
    },
    deleteData(item) {
      this.$store.state.news_status = null;
      let data_lenght = this.activityList.length;
      if (data_lenght >= 4) {
        this.$swal
          .fire({
            title: "ต้องการลบรายการนี้ใช่หรือไม่?",
            text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#E53935",
            cancelButtonColor: "#9E9E9E",
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
          })
          .then((res) => {
            if (res.value) {
              item.file.forEach((element) => {
                this.axios.delete(
                  process.env.VUE_APP_API +
                    "/api/v1/eventfile/" +
                    element.event_file_id,
                  this.header_token
                );
              });
              this.axios
                .delete(
                  process.env.VUE_APP_API + "/api/v1/event/" + item.event_id,
                  this.header_token
                )
                .then((response) => {
                  // console.log(response.data);

                  if (response.data) {
                    if (response.data === "delete success") {
                      this.$swal.fire({
                        icon: "success",
                        title: "ลบข้อมูลสำเร็จ",
                        showConfirmButton: false,
                        timer: 1000,
                      });
                      this.getActivityList();
                      this.$emit("getNews", "delete");
                      this.$store.state.event_status = this.current_position;
                      this.$store.state.news_status = true;
                      this.$store.state.morning_status = true;
                    } else {
                      this.$swal.fire("ไม่สามารถลบได้", "", "error");
                    }
                  }
                });
            }
          });
      } else if (data_lenght < 4)
        this.$swal.fire({
          icon: "error",
          title: "ไม่สามารถลบข้อมูลได้ เนื่องจากต้องมีข้อมูลอย่างน้อย 3 ข้อ",
          showConfirmButton: false,
          timer: 1000,
        });
    },
    // date methods
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    lenght_data(data) {
      const max_lenght = 40;
      let data_string = "";
      for (let index = 0; index < max_lenght; index++) {
        data_string += data[index];
      }
      data_string += "...";
      if (data.length < max_lenght) {
        return data;
      } else {
        return data_string;
      }
    },
    checkLengthFileName(val) {
      let name_file = "";
      if (val.length < 45) {
        name_file = val;
        return name_file;
      } else {
        name_file = val.slice(0, 40);
        name_file += ".png";
        return name_file;
      }
    },
  },
};
</script>
<style lang="scss">
// style text editor
.announcement_btn_bar {
  background-image: linear-gradient(#ffffff, #cccccc);
  font-size: 9px;
}
.ql-toolbar {
  background-image: linear-gradient(#e5e5e5, white);
}
.ql-toolbar.ql-snow .ql-formats {
  margin-right: 15px;
  border: 1px solid #bec0c2;
}
.quill-code {
  border: none;
  height: auto;
  > code {
    width: 100%;
    margin-top: 50px;
    padding: 1rem;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0;
    height: 10rem;
    overflow-y: auto;
    resize: vertical;
  }
}
.ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 0px;
  height: 250px;
}
</style>
